import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../../contexts/SessionContext';
import API_URL from '../../constants/environment';
import {
    BulkUpdateInventoryStatusInput,
    BulkUpdateInventoryStatusResponse,
    InventoryItemEntry,
    UpdateInventoryItemInput,
} from '../../types/inventory';

interface UpdateInventoryItemResponse {
    item: InventoryItemEntry;
}

const updateInventoryItem = async (
    input: UpdateInventoryItemInput,
    sessionId: string | null,
): Promise<UpdateInventoryItemResponse> => {
    const { data } = await axios.post(`${API_URL}/inventory/update`, input, {
        headers: { Authorization: sessionId },
    });
    return data;
};

const bulkUpdateInventoryStatus = async (
    input: BulkUpdateInventoryStatusInput,
    sessionId: string | null,
): Promise<BulkUpdateInventoryStatusResponse> => {
    const { data } = await axios.post(`${API_URL}/inventory/update`, input, {
        headers: { Authorization: sessionId },
    });
    return data;
};

export const useUpdateInventoryItem = (
    options?: UseMutationOptions<UpdateInventoryItemResponse, unknown, UpdateInventoryItemInput>,
) => {
    const sessionContext = useContext(SessionContext);

    return useMutation({
        mutationFn: (input: UpdateInventoryItemInput) =>
            updateInventoryItem(input, sessionContext?.sessionId ?? null),
        ...options,
    });
};

export const useBulkUpdateInventoryStatus = (
    options?: UseMutationOptions<
        BulkUpdateInventoryStatusResponse,
        unknown,
        BulkUpdateInventoryStatusInput
    >,
) => {
    const sessionContext = useContext(SessionContext);

    return useMutation({
        mutationFn: (input: BulkUpdateInventoryStatusInput) =>
            bulkUpdateInventoryStatus(input, sessionContext?.sessionId ?? null),
        ...options,
    });
};
